import React from 'react'
import Spinner from 'react-bootstrap/Spinner';

export default function LoadingButton({style}) {
  return (
    <Spinner style={style} animation="border" variant="light" />
  )
}
